import React from 'react';
import { FiEyeOff, FiLock, FiUserX, FiShield } from 'react-icons/fi';
import './Privacy.css';

const privacyFeatures = [
  {
    icon: <FiEyeOff />,
    title: 'Hidden Personal Info',
    desc: 'Your real name, phone number, and email are never shown to other users. You choose what to share.',
  },
  {
    icon: <FiUserX />,
    title: 'Anonymous Profiles',
    desc: 'Other users can only see your display name and photos. No personal contact details are ever exposed.',
  },
  {
    icon: <FiLock />,
    title: 'Encrypted Communications',
    desc: 'All messages and video calls are end-to-end encrypted. Nobody can intercept your conversations.',
  },
  {
    icon: <FiShield />,
    title: 'Screenshot Protection',
    desc: 'Video calls are protected from screen recording and screenshots to keep your private moments safe.',
  },
];

const Privacy = () => {
  return (
    <section className="privacy" id="privacy">
      <div className="container">
        <div className="section-header">
          <span className="section-tag privacy-tag">🔒 User Privacy</span>
          <h2>Your Identity is <span className="gradient-text">Fully Protected</span></h2>
          <p>We never share your personal information with other users. Your privacy is our top priority.</p>
        </div>
        <div className="privacy-highlight">
          <div className="privacy-shield-icon">
            <FiShield size={32} />
          </div>
          <div className="privacy-highlight-text">
            <h3>Other users cannot see your:</h3>
            <div className="privacy-hidden-items">
              <span className="hidden-item">📵 Phone Number</span>
              <span className="hidden-item">📧 Email Address</span>
              <span className="hidden-item">👤 Real Name</span>
              <span className="hidden-item">📍 Exact Location</span>
            </div>
          </div>
        </div>
        <div className="privacy-grid">
          {privacyFeatures.map((f, i) => (
            <div className="privacy-card" key={i}>
              <div className="privacy-card-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Privacy;
